import { personalInfo } from "./personal"

/**
 * Hour formatter for the home time zone — Intl.DateTimeFormat construction
 * is expensive, so one instance is built at module scope and reused.
 */
const homeHourFormatter = new Intl.DateTimeFormat("en-US", {
  timeZone: personalInfo.timeZone,
  hour: "numeric",
  hour12: false,
})

/**
 * Hour of day (0–23) in the home time zone, whatever the visitor's own
 * zone. Falls back to the visitor's local hour if Intl rejects the zone
 * (should never happen on modern browsers).
 */
export function homeHour(date: Date = new Date()): number {
  try {
    // en-US formatter sometimes returns "24" at midnight; normalize.
    const h = parseInt(homeHourFormatter.format(date), 10)
    return Number.isFinite(h) ? h % 24 : 0
  } catch {
    return date.getHours()
  }
}
